module.exports = __webpack_public_path__ + "img/diagram-direction-electronics-1305360-min.db6bd8c8.jpg";